import {  useQuery,useQueryClient,useMutation  } from '@tanstack/react-query';
import { listLoads,fetchVans,fetchLoadDetails,createLoad,deleteLoad,updateBarcode,downloadLoadDetails } from './loads.api';

export const useLoads = ({ filters, page, perPage }) => {
    return useQuery({
      queryKey: ['loads', filters, page, perPage],
      queryFn: () => listLoads({ filters, page, perPage }),
      keepPreviousData: true
    });
  };

export const useVans = () => {
    return useQuery({
      queryKey: ['allvans'],
      queryFn: async () => {
        const response = await fetchVans();
        return Array.isArray(response) ? response : []; 
      },
      keepPreviousData: true,
    });
  };
  export function useLoadDetails(loadid, open,) {
    return useQuery({
      queryKey: ['load-details', loadid],
      queryFn: () => fetchLoadDetails(loadid),
      enabled: !!loadid && open
    });
  }
  export const useCreateLoad = (onSuccess, onError) => {
    return useMutation({
      mutationFn: createLoad,
      onSuccess,
      onError,
    });
  };
  export const useDeleteLoad = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: deleteLoad,
      onSuccess: () => {
        queryClient.invalidateQueries(['loads']); // Refetch list after delete
      },
    });
  };

  export const useUpdateBarcode = (onSuccess, onError) => {
    return useMutation({
      mutationFn: updateBarcode,
      onSuccess,
      onError,
    });
  };
  export function useDownloadLoadDetails(loadid) {
    return useQuery({
      queryKey: ['download-load', loadid],
      queryFn: () => downloadLoadDetails(loadid),
      enabled: !!loadid 
    });
  }
